module.exports = __webpack_public_path__ + "img/bouddi-grey-icon.ce95677.webp";